export default __webpack_public_path__ + "static/media/sgs-aviation-services.b475d022.jpg";